/**
 * @generated SignedSource<<aab2014e6b6a372a0aaef2064dc3535c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ChargesSummary_booking$data = {
  readonly startSlot: {
    readonly __typename: string;
    readonly " $fragmentSpreads": FragmentRefs<"NotificationsInner_slot">;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"BookingCharges_booking" | "RequestChargesEstimation_booking" | "useShouldPresentBookingAsLockedRequest_booking">;
  readonly " $fragmentType": "ChargesSummary_booking";
};
export type ChargesSummary_booking$key = {
  readonly " $data"?: ChargesSummary_booking$data;
  readonly " $fragmentSpreads": FragmentRefs<"ChargesSummary_booking">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "patronLoyalty"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "ChargesSummary_booking",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "startSlot",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "NotificationsInner_slot"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useShouldPresentBookingAsLockedRequest_booking"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "patronLoyalty",
          "variableName": "patronLoyalty"
        }
      ],
      "kind": "FragmentSpread",
      "name": "BookingCharges_booking"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RequestChargesEstimation_booking"
    }
  ],
  "type": "Booking",
  "abstractKey": "__isBooking"
};

(node as any).hash = "f4a7be0ea72f15b0bd5ed9bbfcc96461";

export default node;
